import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Plus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Plus } from '@sravni/design-system-icons'
 *
 * <Plus />
 * ```
 */
var Plus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Plus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 10v6m-6-6h6-6Zm6 0h6-6Zm0 0V4v6Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Plus };
//# sourceMappingURL=Plus.js.map
